<div class="grid flex justify-content-center">
    <ng-otp-input class="font-subtitle-light" #ngOtpInput  (onInputChange)="onOtpChange($event)" [config]="{length:6, allowNumbersOnly: true}"></ng-otp-input>
</div>
